import { FETCH_ENV } from "./actions.types";

export const fetchEnv = (data) => ({
    type: FETCH_ENV,
    payload: data
})